<script>
import { put, get } from '@rails/request.js'

export default {
  props: {
    event: Object,
  },
  mounted() {
    this.$refs.dropdown?.addEventListener('show.bs.dropdown', this.moveDropdownToBody)
  },
  data() {
    return {
      isEditable() {
        return !!this.event.extendedProps.editUrl
      },
      isShift() {
        return !!this.event.extendedProps.shiftUrl
      },
      statusStyle: {
        padding: "0.2rem",
        "margin-bottom": "-4px",
        top: "-2px",
        left: "-1px",
        position: "relative",
        color: this.event.extendedProps.houseColor,
        backgroundColor: this.event.extendedProps.houseBackgroundColor

      },
      statusClass: [
        "me-1",
        "border-end",
        "border-light",
        "d-inline-block",
      ]
    }
  },
  methods: {
    moveDropdownToBody: function() {
      document.body.prepend(
        this.$refs.dropdown.querySelector(':scope > .dropdown-menu')
      )
      this.$refs.dropdown.removeEventListener('show.bs.dropdown', this.moveDropdownToBody)
    },
    swapShift: async function() {
      const response = await get(this.event.extendedProps.swappableUrl)
      if (!response.ok) {
        return
      }

      const content = await response.text
      $("#app-modal .modal-content").html(content)
      bootstrap.Modal.getOrCreateInstance("#app-modal").show()
    },
    editShift: async function() {
      const response = await get(this.event.extendedProps.editUrl)
      if (!response.ok) {
        return
      }

      const content = await response.text
      $("#app-modal .modal-content").html(content)
      bootstrap.Modal.getOrCreateInstance("#app-modal").show()
    }
  }
}
</script>
<template>
  <div class="d-flex align-items-stretch user-select-none">
    <template v-if="this.isShift()">
      <template v-if="this.isEditable()">
        <a v-if="event.extendedProps.noShow" :style="statusStyle" :class="statusClass" :href="event.extendedProps.noShowUrl" rel="nofollow" data-remote="true" data-method="patch">
          <span class="bi bi-eye-slash-fill" :title="this.$i18n.t('timetable.shifts.no_show')"></span>
        </a>
        <a v-else :style="statusStyle" :class="statusClass" :href="event.extendedProps.movedIntoUrl" rel="nofollow" data-remote="true" data-method="patch">
          <span v-if="event.extendedProps.movedInto" class="bi bi-geo-alt-fill" :title="this.$i18n.t('timetable.shifts.position_filled')"></span>
          <span v-else class="bi bi-geo-alt" :title="this.$i18n.t('timetable.shifts.position_unfilled')"></span>
        </a>
      </template>
      <span v-else :style="statusStyle" :class="statusClass">
        <span v-if="event.extendedProps.movedInto" class="bi bi-geo-alt-fill" :title="this.$i18n.t('timetable.shifts.position_filled')"></span>
        <span v-else class="bi bi-geo-alt" :title="this.$i18n.t('timetable.shifts.position_unfilled')"></span>
      </span>
    </template>

    <div>
      <span class="me-1">{{ event.title }}</span>
      <template v-if="this.isShift() && (this.isEditable() || event.extendedProps.comment)">
        <span class="dropdown" ref="dropdown">
          <button style="color: inherit" class="dropdown-toggle btn btn-sm p-0 px-1" data-bs-toggle="dropdown" aria-expanded="false">
            <span v-if="event.extendedProps.comment" class="bi bi-chat-left-dots me-1"></span>
          </button>
          <ul class="dropdown-menu">
            <template v-if="this.isEditable() && (event.extendedProps.status || event.extendedProps.noShow)">
              <p class="pt-2 px-3">
                <div v-if="event.extendedProps.noShow">
                  <span class="bi bi-exclamation-circle-fill text-danger"></span>
                  {{ this.$i18n.t('timetable.shifts.conflicts.no_show') }}
                </div>
                <div v-if="event.extendedProps.status & 2">
                  <span class="bi bi-exclamation-circle-fill text-danger"></span>
                  {{ this.$i18n.t('timetable.shifts.conflicts.parallel_shift') }}
                </div>
                <div v-if="event.extendedProps.status & 8">
                  <span class="bi bi-exclamation-circle-fill text-danger"></span>
                  {{ this.$i18n.t('timetable.shifts.conflicts.no_attendance') }}
                </div>
                <div v-if="event.extendedProps.status & 16">
                  <span class="bi bi-exclamation-circle-fill text-danger"></span>
                  {{ this.$i18n.t('timetable.shifts.conflicts.not_present') }}
                </div>
                <div v-if="event.extendedProps.status & 4">
                  <span class="bi bi-exclamation-circle-fill text-warning"></span>
                  {{ this.$i18n.t('timetable.shifts.conflicts.exceeding_working_time_limit') }}
                </div>
                <div v-if="event.extendedProps.status & 1">
                  <span class="bi bi-exclamation-circle-fill text-warning"></span>
                  {{ this.$i18n.t('timetable.shifts.conflicts.no_break') }}
                </div>
              </p>
              <hr class="dropdown-divider">
            </template>
            <template v-if="event.extendedProps.comment">
              <p class="pt-2 px-3">{{ event.extendedProps.comment }}</p>
              <li v-if="this.isEditable()"><hr class="dropdown-divider"></li>
            </template>
            <template v-if="this.isEditable()">
              <li>
                <span class="dropdown-item" @click="this.editShift" style="cursor: pointer;">
                  <span class="bi bi-pencil"></span>
                  {{ this.$i18n.t('timetable.shifts.edit') }}
                </span>
              </li>
              <li>
                <a class="dropdown-item" :href="event.extendedProps.duplicateUrl" rel="nofollow" data-remote="true" data-method="post">
                  <span class="bi bi-copy"></span>
                  {{ this.$i18n.t('timetable.shifts.duplicate') }}
                </a>
              </li>
              <li>
                <span class="dropdown-item" @click="this.swapShift" style="cursor: pointer;">
                  <span class="bi bi-arrow-repeat"></span>
                  {{ this.$i18n.t('timetable.shifts.swap') }}
                </span>
              </li>
              <li>
                <a class="dropdown-item" :href="event.extendedProps.noShowUrl" rel="nofollow" data-remote="true" data-method="patch">
                  <template v-if="!event.extendedProps.noShow">
                    <span class="bi bi-eye-slash-fill"></span>
                    {{ this.$i18n.t('timetable.shifts.no_show') }}
                  </template>
                  <template v-else>
                    <span class="bi bi-eye"></span>
                    {{ this.$i18n.t('timetable.shifts.show') }}
                  </template>
                </a>
              </li>
              <li><hr class="dropdown-divider"></li>
              <li>
                <a class="dropdown-item" :href="event.extendedProps.linkUrl">
                    <span class="bi bi-link-45deg"></span>
                    {{ event.title }}
                </a>
              </li>
              <li><hr class="dropdown-divider"></li>
              <li>
                <a class="text-danger dropdown-item" :href="event.extendedProps.shiftUrl" rel="nofollow" data-remote="true" data-method="delete">
                  <span class="bi bi-trash"></span>
                  {{ this.$i18n.t('timetable.shifts.delete') }}
                </a>
              </li>
            </template>
          </ul>
        </span>
      </template>
    </div>
  </div>
</template>
